import React from 'react';

import { Table, TableColumn, formatNumber } from '@column/column-ui-kit';

import { RelativeTime } from '~/elements';
import { CardTransaction } from '~/repositories/CardTransactionRepository';
import { formatString } from '~/util';

export type CardTransactionRow = CardTransaction;

const formatAmount = (amount?: { amount: number; currencyCode: string }): string => {
  if (!amount) {
    return '-';
  }

  return formatNumber(amount.amount, amount.currencyCode);
};

export const cardTransactionColumns: TableColumn<CardTransactionRow>[] = [
  {
    header: 'Merchant Name',
    id: 'merchant',
    width: { min: 180, max: '1fr' },
    cell: ({ row }) => <Table.TextCell weight="medium" value={row.cardAcceptorDetails?.name || '-'} />,
  },
  {
    header: 'Card ID',
    accessor: 'cardId',
    width: { min: 230, max: '1.4fr' },
    cell: ({ value }) => <Table.TextCell displayVariant="monospaced" value={(value as string) || '-'} />,
  },
  {
    header: 'Type',
    accessor: 'type',
    width: { min: 140, max: '0.8fr' },
    cell: ({ value }) => <Table.TextCell value={value ? formatString(value as string) : '-'} />,
  },
  {
    header: 'Cardholder Authorized',
    id: 'cardholderAuthorizedAmount',
    width: { min: 160, max: '0.9fr' },
    cell: ({ row }) => <Table.TextCell value={formatAmount(row.totalAmounts?.cardholderAuthorized)} />,
  },
  {
    header: 'Cardholder Settled',
    id: 'cardholderSettledAmount',
    width: { min: 150, max: '0.9fr' },
    cell: ({ row }) => <Table.TextCell value={formatAmount(row.totalAmounts?.cardholderSettled)} />,
  },
  {
    header: 'Created',
    accessor: 'createdAt',
    width: { min: 150, max: '0.8fr' },
    cell: ({ value }) => <Table.Cell>{value ? <RelativeTime timestamp={value as Date} /> : '-'}</Table.Cell>,
  },
];
